module.exports = function (width, options) {
  if (options === undefined) {
    options = width;
    width = Gryphon.widgets.MEDIA_SKINNY_MAX_WIDTH;
  }
  return $(window).width() <= width ? options.fn(this) : options.inverse(this);
};
